import { ColumnsComponentContent } from '../../../types/elearning';
import ComponentRenderer from './ComponentRenderer';

interface ColumnsViewerProps {
  content: ColumnsComponentContent;
}

export default function ColumnsViewer({ content }: ColumnsViewerProps) {
  const { columnCount, columns } = content;

  if (!columns || columns.length === 0) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4">
        <p className="text-sm text-gray-500">No columns defined</p>
      </div>
    );
  }

  const gridCols = columnCount === 2 ? 'md:grid-cols-2' : 'md:grid-cols-3';
  const gap = columnCount === 2 ? 'gap-6' : 'gap-4';

  return (
    <div className={`grid grid-cols-1 ${gridCols} ${gap} mb-4`}>
      {columns.map((column, columnIndex) => (
        <div key={columnIndex} className="space-y-4">
          {column.components
            .sort((a, b) => a.order - b.order)
            .map((component) => (
              <ComponentRenderer key={component.id} component={component} />
            ))}
        </div>
      ))}
    </div>
  );
}
